<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $t('messages.absenteeism'),
                        href: null,
                    },
                    {
                        name: $tc('messages.trimesters', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                    v-if="attendanceRecords.length"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    v-for="header in headers"
                                    :key="header"
                                    class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ header }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(attendanceRecord, index) in attendanceRecords"
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                            >
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900">
                                    {{ attendanceRecord.student.full_name }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ attendanceRecord.group.name }}
                                </td>
                                <td
                                    v-for="trimester in attendanceRecord.trimesters"
                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500"
                                >
                                    <span class="inline-block"> {{ trimester['percent'] }}% </span>
                                    <svg
                                        v-if="trimester.diff === 'worse'"
                                        width="24"
                                        height="24"
                                        style="color: #fc8181"
                                        class="inline-block"
                                    >
                                        <rect width="24" height="24" fill="none" rx="0" ry="0" />
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M22.5282 5.24023H13.6982C13.4482 5.24023 13.2282 5.39023 13.1382 5.62023C13.0482 5.85023 13.1082 6.11023 13.2882 6.28023L16.2282 9.04023L13.0782 12.1902L9.26817 8.38023C9.15817 8.26023 9.00817 8.20023 8.84817 8.20023C8.68817 8.20023 8.53817 8.26023 8.42817 8.38023L1.30817 15.4902C1.18817 15.6002 1.12817 15.7502 1.12817 15.9102C1.12817 16.0702 1.18817 16.2202 1.30817 16.3302L3.55817 18.5802C3.67817 18.7002 3.82817 18.7602 3.97817 18.7602C4.12817 18.7602 4.28817 18.7002 4.39817 18.5802L8.82817 14.1502L12.6382 17.9702C12.8682 18.2002 13.2482 18.2002 13.4882 17.9702L19.3182 12.1502L22.0882 15.0802C22.2582 15.2602 22.5182 15.3202 22.7482 15.2302C22.9782 15.1402 23.1282 14.9202 23.1282 14.6702V5.84023C23.1282 5.51023 22.8582 5.24023 22.5282 5.24023Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                    <svg
                                        v-if="trimester.diff === 'better'"
                                        width="24"
                                        height="24"
                                        style="color: #68d391"
                                        class="inline-block"
                                    >
                                        <rect width="24" height="24" fill="none" rx="0" ry="0" />
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M22.5282 18.7598H13.6982C13.4482 18.7598 13.2282 18.6098 13.1382 18.3798C13.0482 18.1498 13.1082 17.8898 13.2882 17.7198L16.2282 14.9598L13.0782 11.8098L9.26817 15.6198C9.15817 15.7398 9.00817 15.7998 8.84817 15.7998C8.68817 15.7998 8.53817 15.7398 8.42817 15.6198L1.30817 8.50977C1.18817 8.39977 1.12817 8.24977 1.12817 8.08977C1.12817 7.92977 1.18817 7.77977 1.30817 7.66977L3.55817 5.41977C3.67817 5.29977 3.82817 5.23977 3.97817 5.23977C4.12817 5.23977 4.28817 5.29977 4.39817 5.41977L8.82817 9.84977L12.6382 6.02977C12.8682 5.79977 13.2482 5.79977 13.4882 6.02977L19.3182 11.8498L22.0882 8.91977C22.2582 8.73977 22.5182 8.67977 22.7482 8.76977C22.9782 8.85977 23.1282 9.07977 23.1282 9.32977V18.1598C23.1282 18.4898 22.8582 18.7598 22.5282 18.7598Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';

export default {
    components: {
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'filters', 'options', 'attendanceRecords', 'headers'],
};
</script>
